import {
  LikeTwoTone,
  LikeOutlined,
  DislikeTwoTone,
  DislikeOutlined,
} from '@ant-design/icons';
import { useState } from 'react';
import { colors } from 'theme/colors';

import { Button } from 'components/general/Button';
import { FeedbackPopover } from 'components/maxi-ai/feedback/FeedbackPopover';

interface FeedbackThumbsProps {
  messageId: string;
  traceId: string;
  onSubmit: (opts: {
    messageId: string;
    traceId: string;
    thumbsUp: boolean;
    text: string;
  }) => void;
  isSubmitting: boolean;
  selected?: 'like' | 'dislike';
}

export const FeedbackThumbs = ({
  messageId,
  traceId,
  onSubmit,
  isSubmitting,
  selected,
}: FeedbackThumbsProps) => {
  const [open, setOpen] = useState<{
    variant?: 'like' | 'dislike';
    open: boolean;
  }>({ open: false });
  const [text, setText] = useState('');

  const handleCancel = () => {
    setOpen({ open: false });
    setText('');
  };

  const handleSubmit = () => {
    if (!open.variant) return;
    onSubmit({ messageId, traceId, thumbsUp: open.variant === 'like', text });
    // Close popover after submit and reset content
    setOpen({ open: false });
    setText('');
  };

  return (
    <div className="flex gap-2">
      <FeedbackPopover
        open={open.open && open.variant === 'like'}
        title="Additional Feedback"
        value={text}
        onChange={setText}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
        loading={isSubmitting}
        triggerContent={
          <Button
            type="text"
            onClick={() => setOpen({ open: true, variant: 'like' })}
            icon={
              selected === 'like' ? (
                <LikeTwoTone twoToneColor={colors.colorPrimary} />
              ) : (
                <LikeOutlined color={colors.colorPrimary} />
              )
            }
          />
        }
      />

      <FeedbackPopover
        open={open.open && open.variant === 'dislike'}
        title="Additional Feedback"
        value={text}
        onChange={setText}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
        loading={isSubmitting}
        triggerContent={
          <Button
            type="text"
            onClick={() => setOpen({ open: true, variant: 'dislike' })}
            icon={
              selected === 'dislike' ? (
                <DislikeTwoTone twoToneColor={colors.colorPrimary} />
              ) : (
                <DislikeOutlined color={colors.colorPrimary} />
              )
            }
          />
        }
      />
    </div>
  );
};
